<template>
  <v-card style="border-radius: 12px; overflow: hidden;">
    <!-- Dialog Header -->
    <v-toolbar flat color="primary" dark class="px-2">
      <v-avatar color="primary lighten-1" size="40" class="mr-3">
        <v-icon dark>person</v-icon>
      </v-avatar>
      <v-toolbar-title class="subheading font-weight-bold">
        {{ (clienteExibicao && clienteExibicao.pessoa) ? clienteExibicao.pessoa.nome_completo : 'Detalhes do Cliente' }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('fechar')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-progress-linear v-if="loadingDetalhes" indeterminate color="primary" class="ma-0"></v-progress-linear>

    <v-card-text class="pa-4" style="max-height: 80vh; overflow-y: auto;">
      <!-- Main Info Cards -->
      <v-card outline color="grey lighten-4" class="pa-3 mb-4" style="border-radius: 8px;">
        <v-layout wrap align-center justify-space-between>
          <v-flex xs12 sm6 md3 class="py-1">
            <div class="caption grey--text text--darken-1 font-weight-bold">IDENTIFICADOR</div>
            <div class="subheading font-weight-bold primary--text">
              <v-icon small color="primary" class="mr-1">fingerprint</v-icon>
              {{ (clienteExibicao && clienteExibicao.pessoa && clienteExibicao.pessoa.id_pessoa) ? clienteExibicao.pessoa.id_pessoa : 'Não informado' }}
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="py-1">
            <div class="caption grey--text text--darken-1 font-weight-bold">CADASTRO</div>
            <div class="body-2">
              <v-icon small color="grey" class="mr-1">event</v-icon>
              <template v-if="clienteExibicao && clienteExibicao.pessoa && clienteExibicao.pessoa.data_cadastro">
                {{ clienteExibicao.pessoa.data_cadastro | formatDate('DD/MM/YYYY') }}
              </template>
              <template v-else>Não informado</template>
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="py-1">
            <div class="caption grey--text text--darken-1 font-weight-bold">LOCALIDADE</div>
            <div class="body-2">
              <v-icon small color="grey" class="mr-1">place</v-icon>
              {{ (clienteExibicao && clienteExibicao.pessoa && clienteExibicao.pessoa.local) ? clienteExibicao.pessoa.local : 'Não informado' }}
            </div>
          </v-flex>

          <v-flex xs12 sm6 md3 class="py-1 text-xs-right">
            <v-chip small :color="(clienteExibicao && clienteExibicao.eh_assinante) ? 'success' : 'grey'" text-color="white" class="ma-0 font-weight-bold">
              <v-icon small left>{{ (clienteExibicao && clienteExibicao.eh_assinante) ? 'check_circle' : 'cancel' }}</v-icon>
              {{ (clienteExibicao && clienteExibicao.eh_assinante) ? 'Assinante' : 'Não Assinante' }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card>

      <!-- Single Inscrição Card -->
      <v-card outline class="pa-3 mb-4" style="border-radius: 8px;" v-if="inscricao">
        <v-layout align-center class="mb-3">
          <v-avatar color="primary lighten-5" size="36" class="mr-2">
            <v-icon color="primary" small v-if="inscricao.rede">ac_unit</v-icon>
            <v-icon color="primary" small v-else>local_gas_station</v-icon>
          </v-avatar>
          <div class="subheading font-weight-bold primary--text">
            {{ inscricao.rede ? 'Inscrição na Rede de Postos' : 'Inscrição no Posto' }}
          </div>
        </v-layout>

        <v-divider class="mb-3"></v-divider>

        <v-layout wrap justify-space-between>
          <v-flex xs12 sm6 md4 class="my-2">
            <span class="grey--text text--darken-1">Recebe E-mail:</span>
            <b class="ml-1">{{ inscricao.inscrito_email ? 'SIM' : 'NÃO' }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-2">
            <span class="grey--text text--darken-1">Recebe Notificações:</span>
            <b class="ml-1">{{ inscricao.inscrito_push ? 'SIM' : 'NÃO' }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-2">
            <span class="grey--text text--darken-1">Número de Compras:</span>
            <b class="ml-1">{{ inscricao.numero_compras || 0 }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-2">
            <span class="grey--text text--darken-1">Cliente Plus:</span>
            <b class="ml-1">{{ inscricao.cliente_plus ? 'SIM' : 'NÃO' }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-2">
            <span class="grey--text text--darken-1">Pontuação:</span>
            <b class="ml-1">{{ inscricao.pontuacao || 0 }} pts</b>
          </v-flex>

          <v-flex xs12 class="mt-3">
            <v-btn small outline round color="primary" @click="tooglePlusCustomer">
              <v-icon left>{{ inscricao.cliente_plus ? 'star' : 'star_outline' }}</v-icon>
              {{ inscricao.cliente_plus ? 'Retirar Status Plus' : 'Tornar Cliente Plus' }}
            </v-btn>
          </v-flex>

          <!-- Purchased Fuels -->
          <v-flex xs12 class="mt-4" v-if="inscricao.combustiveis && inscricao.combustiveis.length > 0">
            <div class="caption font-weight-bold grey--text text--darken-2 mb-2">COMBUSTÍVEIS COMPRADOS</div>
            <v-layout wrap>
              <v-chip v-for="(combustivel, index) in inscricao.combustiveis" :key="index" outline color="primary" class="mr-2 mb-2">
                <svg-filler
                  :path="combustivel.icone ? require(`@/assets/combs/${combustivel.icone}.svg`) : require(`@/assets/combs/gas.svg`)"
                  width="20px"
                  height="20px"
                  :fill="combustivel.color || '#1976D2'"
                  class="mr-2"
                />
                {{ combustivel.nome }}
              </v-chip>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
      <v-alert v-else-if="!loadingDetalhes" :value="true" type="info" outline small class="mb-4">
        Nenhuma inscrição cadastrada para este cliente.
      </v-alert>

      <!-- UNIFIED SUBSCRIPTION & GATEWAY SECTION -->
      <v-card v-if="assinatura" outline class="pa-4 mb-2" style="border-radius: 8px; border-left: 4px solid #1976D2;">
        <v-layout wrap align-center justify-space-between class="mb-3">
          <div class="title font-weight-bold primary--text d-flex align-center">
            <v-icon color="primary" class="mr-2">card_membership</v-icon>
            Dados da Assinatura
          </div>
          <v-chip small :color="statusAssinaturaInfo(assinatura).cor" text-color="white" class="font-weight-bold">
            {{ statusAssinaturaInfo(assinatura).texto }}
          </v-chip>
        </v-layout>

        <v-divider class="mb-3"></v-divider>

        <v-layout wrap justify-space-between>
          <v-flex xs12 sm6 md4 class="my-1">
            <span class="grey--text text--darken-1">Plano:</span>
            <b class="ml-1">{{ assinatura.plano ? assinatura.plano.descricao : 'Não informado' }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-1" v-if="assinatura.plano">
            <span class="grey--text text--darken-1">Valor:</span>
            <b class="ml-1 primary--text">{{ assinatura.plano.valor | currency({fractionCount: 2}) }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-1" v-if="assinatura.plano">
            <span class="grey--text text--darken-1">Periodicidade:</span>
            <b class="ml-1">{{ formatarIntervaloPlano(assinatura.plano.intervalo) }}</b>
          </v-flex>

          <v-flex xs12 sm6 md4 class="my-1">
            <span class="grey--text text--darken-1">Data Assinatura:</span>
            <b class="ml-1">{{ assinatura.data | formatDate('DD/MM/YYYY') }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-1">
            <span class="grey--text text--darken-1">Data Cobrança:</span>
            <b class="ml-1">{{ assinatura.data_cobranca | formatDate('DD/MM/YYYY') }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-1">
            <span class="grey--text text--darken-1">Encerramento:</span>
            <b class="ml-1">{{ assinatura.data_encerramento | formatDate('DD/MM/YYYY') }}</b>
          </v-flex>

          <v-flex xs12 sm6 md4 class="my-1" v-if="assinatura.cancelado && assinatura.data_cancelamento">
            <span class="grey--text text--darken-1">Data Cancelamento:</span>
            <b class="ml-1 error--text">{{ assinatura.data_cancelamento | formatDate('DD/MM/YYYY') }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-1" v-if="assinatura.veiculo">
            <span class="grey--text text--darken-1">Veículo:</span>
            <b class="ml-1">{{ assinatura.veiculo.marca }} {{ assinatura.veiculo.modelo }}</b>
          </v-flex>
          <v-flex xs12 sm6 md4 class="my-1" v-if="assinatura.id_inscricao">
            <span class="grey--text text--darken-1">ID Inscrição:</span>
            <b class="ml-1">{{ assinatura.id_inscricao }}</b>
          </v-flex>
        </v-layout>

        <!-- Gateway Action Button -->
        <v-layout justify-center class="mt-4">
          <v-btn small color="primary" outline round :loading="loadingGateway(assinatura.id)" @click="carregarDetalhesGateway(assinatura.id)">
            <v-icon left>refresh</v-icon> Consultar Gateway Integrado
          </v-btn>
        </v-layout>

        <!-- Gateway Details Display -->
        <template v-if="getGatewayData(assinatura.id)">
          <v-card flat color="blue-grey lighten-5" class="pa-3 mt-4" style="border-radius: 8px;">
            <v-layout wrap align-center justify-space-between>
              <v-flex xs12 sm6>
                <div class="subheading font-weight-bold primary--text d-flex align-center">
                  <v-icon color="primary" class="mr-2">account_balance_wallet</v-icon>
                  Gateway: {{ getGatewayData(assinatura.id).gateway ? getGatewayData(assinatura.id).gateway.nome : 'Integrado' }}
                </div>
              </v-flex>

              <v-flex xs12 class="mt-2" v-if="getGatewayLink(assinatura.id)">
                <v-divider class="my-2"></v-divider>
                <span class="font-weight-bold grey--text text--darken-2">Link de Pagamento Recorrente:</span>
                <a :href="getGatewayLink(assinatura.id).url || getGatewayLink(assinatura.id).payment_url" target="_blank" class="ml-2 primary--text font-weight-bold" style="word-break: break-all;">
                  {{ getGatewayLink(assinatura.id).url || getGatewayLink(assinatura.id).payment_url || 'Abrir Link' }}
                  <v-icon small color="primary" class="ml-1">open_in_new</v-icon>
                </a>
              </v-flex>

              <!-- Cobranças Table -->
              <v-flex xs12 class="mt-3">
                <v-divider class="my-2"></v-divider>
                <div class="caption font-weight-bold grey--text text--darken-2 mb-2">COBRANÇAS REGISTRADAS NO GATEWAY</div>
                <v-alert v-if="!getGatewayCobrancas(assinatura.id) || getGatewayCobrancas(assinatura.id).length === 0" :value="true" type="info" outline small>
                  Nenhuma cobrança individual registrada no gateway.
                </v-alert>

                <v-data-table
                  v-else
                  :headers="headersCobrancas"
                  :items="getGatewayCobrancas(assinatura.id)"
                  class="elevation-1"
                  hide-actions
                  style="border-radius: 6px;"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <template v-if="props.item.dueDate || props.item.created_at">
                        {{ (props.item.dueDate || props.item.created_at) | formatDate('DD/MM/YYYY') }}
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td>
                      <template v-if="props.item.paymentDate">
                        {{ props.item.paymentDate | formatDate('DD/MM/YYYY') }}
                      </template>
                      <template v-else>-</template>
                    </td>
                    <td class="font-weight-bold">{{ props.item.value | currency({fractionCount: 2}) }}</td>
                    <td>{{ formatarFormaPagamento(props.item.billingType) }}</td>
                    <td>
                      <v-chip small :color="corStatusCobranca(props.item.status)" text-color="white">
                        {{ formatarStatusCobranca(props.item.status) }}
                      </v-chip>
                    </td>
                    <td>
                      <v-btn v-if="props.item.invoiceUrl || props.item.bankSlipUrl" icon small :href="props.item.invoiceUrl || props.item.bankSlipUrl" target="_blank" title="Ver Fatura">
                        <v-icon small color="primary">receipt</v-icon>
                      </v-btn>
                      <span v-else>-</span>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-card>
        </template>

        <v-alert v-if="getGatewayError(assinatura.id)" :value="true" type="error" outline small class="mt-3">
          {{ getGatewayError(assinatura.id) }}
        </v-alert>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  props: ['cliente'],
  data: () => ({
    detalhesCliente: null,
    loadingDetalhes: false,
    detalhesGatewayMap: {},
    headersCobrancas: [
      { text: 'Vencimento', value: 'dueDate', sortable: false },
      { text: 'Pagamento', value: 'paymentDate', sortable: false },
      { text: 'Valor', value: 'value', sortable: false },
      { text: 'Forma', value: 'billingType', sortable: false },
      { text: 'Status', value: 'status', sortable: false },
      { text: 'Comprovante', value: 'invoiceUrl', sortable: false }
    ]
  }),
  filters: {
    formatDate (value, format = 'DD/MM/YYYY') {
      if (!value) return '-'
      try {
        return moment(String(value)).format(format)
      } catch (e) {
        return String(value)
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    },
    clienteExibicao () {
      return this.detalhesCliente || this.cliente
    },
    inscricao () {
      const c = this.clienteExibicao
      if (!c || !c.inscricao_posto) return null
      if (Array.isArray(c.inscricao_posto)) {
        return c.inscricao_posto[0] || null
      }
      return c.inscricao_posto
    },
    assinatura () {
      const c = this.clienteExibicao
      return (c && c.assinatura) ||
             (this.inscricao && this.inscricao.assinatura) ||
             null
    }
  },
  mounted () {
    this.carregarDetalhes()
  },
  methods: {
    carregarDetalhes () {
      if (!this.cliente || !this.cliente.id_cliente) return
      this.loadingDetalhes = true
      const params = {
        id_cliente: this.cliente.id_cliente,
        posto: this.posto ? this.posto.cnpj : undefined
      }
      this.$store.dispatch('detalharInscritoVendedor', params).then(res => {
        this.detalhesCliente = res
        if (res && res.assinatura && res.assinatura.id) {
          this.carregarDetalhesGateway(res.assinatura.id)
        }
      }).catch((err) => {
        console.error('Erro ao carregar detalhes do cliente:', err)
      }).finally(() => {
        this.loadingDetalhes = false
      })
    },
    formatDate (value, format = 'DD/MM/YYYY') {
      if (!value) return '-'
      try {
        return moment(String(value)).format(format)
      } catch (e) {
        return String(value)
      }
    },
    carregarDetalhesGateway (idAssinatura) {
      if (!idAssinatura) return
      this.$set(this.detalhesGatewayMap, idAssinatura, { loading: true, data: null, error: null })
      this.$store.dispatch('obterDetalhesAssinaturaGateway', idAssinatura).then((res) => {
        this.$set(this.detalhesGatewayMap, idAssinatura, { loading: false, data: res, error: null })
      }).catch((err) => {
        this.$set(this.detalhesGatewayMap, idAssinatura, { loading: false, data: null, error: err.message })
      })
    },
    loadingGateway (idAssinatura) {
      const state = this.detalhesGatewayMap[idAssinatura]
      return state ? state.loading : false
    },
    getGatewayData (idAssinatura) {
      const state = this.detalhesGatewayMap[idAssinatura]
      return (state && state.data) ? state.data : null
    },
    getGatewayError (idAssinatura) {
      const state = this.detalhesGatewayMap[idAssinatura]
      return (state && state.error) ? state.error : null
    },
    getGatewayLink (idAssinatura) {
      const data = this.getGatewayData(idAssinatura)
      if (!data || !data.gateway || !data.gateway.detalhes) return null
      return data.gateway.detalhes.link_pagamento || data.gateway.detalhes.link
    },
    getGatewayCobrancas (idAssinatura) {
      const data = this.getGatewayData(idAssinatura)
      if (!data || !data.gateway || !data.gateway.detalhes) return []
      const det = data.gateway.detalhes
      return det.cobrancas || det.cobrancas_assinatura || []
    },
    formatarStatusCobranca (status) {
      if (!status) return 'DESCONHECIDO'
      const st = String(status).toUpperCase()
      if (st === 'RECEIVED' || st === 'CONFIRMED' || st === 'PAID') return 'PAGO'
      if (st === 'PENDING' || st === 'WAITING' || st === 'UNPAID') return 'PENDENTE'
      if (st === 'OVERDUE') return 'VENCIDO'
      if (st === 'REFUNDED') return 'ESTORNADO'
      return st
    },
    corStatusCobranca (status) {
      if (!status) return 'grey'
      const st = String(status).toUpperCase()
      if (st === 'RECEIVED' || st === 'CONFIRMED' || st === 'PAID') return 'success'
      if (st === 'PENDING' || st === 'WAITING' || st === 'UNPAID') return 'PENDENTE'
      if (st === 'OVERDUE') return 'error'
      return 'info'
    },
    formatarFormaPagamento (tipo) {
      if (!tipo) return 'Outro'
      const t = String(tipo).toUpperCase()
      if (t === 'CREDIT_CARD') return 'Cartão de Crédito'
      if (t === 'BOLETO') return 'Boleto'
      if (t === 'PIX') return 'PIX'
      if (t === 'UNDEFINED') return 'Não definido'
      return t
    },
    statusAssinaturaInfo (ass) {
      if (!ass) return { texto: 'Sem Assinatura', cor: 'grey' }
      if (ass.cancelado) return { texto: 'Cancelada', cor: 'error' }
      if (ass.data_encerramento) {
        const hoje = new Date().toISOString().split('T')[0]
        if (ass.data_encerramento < hoje) {
          return { texto: 'Expirada', cor: 'grey darken-1' }
        }
      }
      if (ass.status) return { texto: 'Ativa / Paga', cor: 'success' }
      return { texto: 'Aguardando Pagamento', cor: 'warning' }
    },
    formatarIntervaloPlano (intervalo) {
      if (!intervalo) return 'Mensal'
      if (intervalo === 1) return 'Mensal (1 mês)'
      if (intervalo === 12) return 'Anual (12 meses)'
      return `A cada ${intervalo} meses`
    },
    tooglePlusCustomer () {
      const isRede = !!(this.inscricao && this.inscricao.rede)
      const data = {
        id_cliente: (this.clienteExibicao && this.clienteExibicao.id_cliente) || this.cliente.id_cliente,
        is_rede: isRede,
        posto: this.posto.cnpj
      }
      this.$store.dispatch('tooglePlus', data).then(() => {
        if (this.inscricao) {
          this.inscricao.cliente_plus = !this.inscricao.cliente_plus
        }
        this.$emit('carregar')
      }).catch((e) => {
        alert(e.message)
      })
    }
  }
}
</script>
